var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoicalFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M437.017,74.985C390.665,28.629,326.732,0,256,0S121.338,28.629,74.986,74.985C28.634,121.341,0,185.268,0,256   s28.634,134.661,74.986,181.014C121.338,483.368,185.268,512,256,512s134.665-28.632,181.017-74.986   C483.368,390.661,512,326.732,512,256S483.368,121.341,437.017,74.985z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M275.559,203.692v-20.978c0-10.064,6.664-12.473,11.491-12.473   c4.675,0,29.338,0,29.338,0v-44.795h-40.4c-44.933,0-54.995,33.168-54.995,54.716v23.529h-26.087v31.61V256h26.365   c0,59.393,0,130.695,0,130.695h52.309c0,0,0-72.295,0-130.695h38.693l1.707-20.554l3.12-31.754H275.559z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoicalFacebook);
export default __webpack_public_path__ + "static/media/soical_facebook.5babe50daff74d442cc2306afc9a93ff.svg";
export { ForwardRef as ReactComponent };